module.exports = __webpack_public_path__ + "components/flag/static/square/pk-8c1364b0280c37c1e8d3810ff3c80da3.svg";